import { createContext, useContext, useState } from 'react';

const TaskTabContext = createContext();

export const TaskTabProvider = ({ children }) => {
  const [taskTab, setTaskTab] = useState('assignedToMe');
  return (
    <TaskTabContext.Provider value={{ taskTab, setTaskTab }}>
      {children}
    </TaskTabContext.Provider>
  );
};

export const useTaskTab = () => useContext(TaskTabContext);
